import React from 'react'
import { Step } from './media'
import guideData from '../../../constants/steps.json'
import { ReactComponent as ArrowLeft } from '../../../assets/ArrowLeft.svg'
import { ReactComponent as ArrowRight } from '../../../assets/ArrowRight.svg'

const MyCarousel = ({
  onNextClick,
  onPreviousClick,
  slide,
}: {
  onNextClick: () => void
  onPreviousClick: () => void
  slide: number
}) => {
  return (
    <div className="flex flex-row w-screen overflow-visible h-full relative">
      <ArrowLeft
        className="cursor-pointer mx-4 absolute top-1/2 -translate-y-1/2 left-0 z-[1000] h-1/2"
        onClick={onPreviousClick}
      />
      <div className="absolute inset-0 w-3/5 sm:w-4/5 mx-auto md:w-full h-full">
        {guideData.map((step, idx) => (
          <Step
            key={`step-${idx + 1}`}
            description={step.title}
            image={step.image}
            innerSteps={step.steps}
            index={idx}
            slide={slide}
          />
        ))}
      </div>
      <ArrowRight
        className="cursor-pointer mx-4 absolute top-1/2 -translate-y-1/2 right-0 z-[1000] h-1/2"
        onClick={onNextClick}
      />
    </div>
  )
}

export default MyCarousel
